import React from 'react';
import Image from 'next/image';
import { FaCheckCircle } from 'react-icons/fa';
import { CardProps } from '../types2';

interface ExtendedCardProps extends CardProps {
  videoUrl?: string;
}

const ItsolutionsCard: React.FC<ExtendedCardProps> = ({ img, title, description1, description2, items, videoUrl }) => {
  const renderItems = () => {
    if (!items || !Array.isArray(items)) return null;

    return items.map((item, index) => (
      <li key={index} className="flex items-start space-x-2 text-gray-medium mb-2">
        <FaCheckCircle className="text-green-accent mt-1" />
        <span>{item.trim()}</span>
      </li>
    ));
  };

  return (
    <div className="flex flex-col space-y-6 items-center bg-white p-4 rounded-lg shadow-lg">
      {img ? (
        <div className="relative w-full mb-5 md:mb-0">
          <Image
            src={img}
            alt={title}
            width={500}
            height={300}
            className="shadow-[20px_20px_0px_0px_var(--green-light)] object-cover rounded-lg image-hover-effect mx-auto"
          />
        </div>
      ) : null}
      <div className="w-full space-y-5 p-4 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold">{title}</h2>
        <p className="text-gray-medium">{description1}</p>
        <p className="text-gray-medium">{description2}</p>
        {videoUrl ? (
          <div className="mt-5 relative mx-auto max-w-md">
            <iframe
              width="100%"
              height="100%"
              src={videoUrl}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="aspect-video rounded-lg shadow-lg"
            ></iframe>
          </div>
        ) : null}
        <ul className="list-none mt-5">
          {renderItems()}
        </ul>
      </div>
    </div>
  );
};

export default ItsolutionsCard;
